//Reducers
import generalReducer, { GeneralState, setGeneral } from './generalReducer';

export default {
    general: generalReducer,
};


export type AppReduxState = {
    general: GeneralState,
}
export {
    setGeneral
}
